import React, { Component } from 'react';
import cx from 'classnames';
import ReactDOM from 'react-dom';
import memoizeOne from 'memoize-one';
import { Image } from '../../../../Image';
import ActionPopup from '../../../../ActionPopup';
import onEnterPressed from '../../../../../common/utils/onEnterPressed';
import UserDetails from './UserDetails';
import { LIST_ITEM } from '../styles/listItem';





















class ListItem extends Component {
  /**
   * @param {Function} fn
   *
   * @return {Function}
   *
   * Prevent event propogation to parent DOM elements.
   * Parent DOM elements onClick handlers should not be triggered.
   *
   */
  withNoEventPropagation = memoizeOne((fn) => (e) => {
    e.stopPropagation();
    e.preventDefault();

    fn(e);
  });

  wrapPopupOptionsWithStopEvent = memoizeOne((popupOptions) => popupOptions.map((option) => ({
    ...option,
    action: this.withNoEventPropagation(option.action)
  })));

  constructor(props) {
    super(props);

    this.state = {};
  }

  /**
   * Invoke onClick only when click is not in the ActionPopup ref.
   * @param {Function} onClickProp
   *
   * @return {Function}
   */
  onClick = (onClickProp) => this.withNoEventPropagation((e) => {
    const { actionBtnRef } = this.state;

    if (actionBtnRef && actionBtnRef.contains(e.target) || !onClickProp) {return;}

    onClickProp(e);
  });

  /**
   * Capture ActionPopup ref
   */
  setActionPopupRef = memoizeOne((el) => {
    if (!el) {
      return;
    }
    // eslint-disable-next-line react/no-find-dom-node
    this.setState({ actionBtnRef: ReactDOM.findDOMNode(el) });
  });

  static UserDetails = UserDetails;

  render() {
    const {
      children,
      onClick: onClickProp,
      hideImage,
      defaultImage,
      defaultImageIcon,
      actionPopupOptions,
      className
    } = this.props;

    return (
      <div
        className={cx('list-item', LIST_ITEM({ onClick: onClickProp }), className)}
        onClick={this.onClick(onClickProp)}
        role="button"
        onKeyDown={onEnterPressed({ onClick: this.onClick(onClickProp) })}
        tabIndex={0}>

        {!hideImage &&
        <Image className="icon" imageUrl={defaultImage} defaultImageIcon={defaultImageIcon} width="90px" height="90px" />}

        {children}
        {actionPopupOptions ?
        <ActionPopup
          options={this.wrapPopupOptionsWithStopEvent(actionPopupOptions)}
          ref={this.setActionPopupRef} /> :

        null}
      </div>);

  }
}

export default ListItem;